export default "__VITE_ASSET__CoRx_gc$__"